const EN_PROGRAMME = "Founder's Analyst Programme";
const TC_PROGRAMME = '創辦人分析師計劃';
const SC_PROGRAMME = '创办人分析师计划';

function rewriteEn(value) {
  if (value == null || value === '') return value;
  return String(value)
    .replace(/2026\s+JUPART\s+Founder(?:'s)?\s+Analyst\s+Programme/gi, EN_PROGRAMME)
    .replace(/JUPART\s+Founder(?:'s)?\s+Analyst\s+Programme/gi, EN_PROGRAMME)
    .replace(/Founder(?:'s)?\s+Analyst\s+Programme/gi, EN_PROGRAMME);
}

function rewriteTc(value) {
  if (value == null || value === '') return value;
  return String(value)
    .replace(/2026\s+JUPART\s+聯招分析師計劃/g, TC_PROGRAMME)
    .replace(/2026\s+JUPART\s+創辦人分析師計劃/g, TC_PROGRAMME)
    .replace(/JUPART\s+聯招分析師計劃/g, TC_PROGRAMME)
    .replace(/JUPART\s+創辦人分析師計劃/g, TC_PROGRAMME)
    .replace(/聯招分析師計劃/g, TC_PROGRAMME);
}

function rewriteSc(value) {
  if (value == null || value === '') return value;
  return String(value)
    .replace(/2026\s+JUPART\s+联招分析师计划/g, SC_PROGRAMME)
    .replace(/2026\s+JUPART\s+创办人分析师计划/g, SC_PROGRAMME)
    .replace(/JUPART\s+联招分析师计划/g, SC_PROGRAMME)
    .replace(/JUPART\s+创办人分析师计划/g, SC_PROGRAMME)
    .replace(/联招分析师计划/g, SC_PROGRAMME);
}

function rewriteAll(value) {
  return rewriteSc(rewriteTc(rewriteEn(value)));
}

export function alignHiringProgrammeNames(post) {
  if (!post) return post;
  return {
    ...post,
    title: rewriteAll(post.title),
    title_en: rewriteAll(post.title_en),
    title_tc: rewriteAll(post.title_tc),
    title_sc: rewriteAll(post.title_sc),
    heroImageAlt: rewriteAll(post.heroImageAlt)
  };
}

export function hiringProgrammeNamesNeedAlign(post) {
  if (!post) return false;
  const aligned = alignHiringProgrammeNames(post);
  return (
    aligned.title !== post.title ||
    aligned.title_en !== post.title_en ||
    aligned.title_tc !== post.title_tc ||
    aligned.title_sc !== post.title_sc ||
    aligned.heroImageAlt !== post.heroImageAlt
  );
}

export async function persistAlignedHiringPost(slug, token) {
  if (!slug || !token) return false;
  const res = await fetch(`/api/hiring/${encodeURIComponent(slug)}?includeArchived=true`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  if (!res.ok) return false;
  const post = await res.json();
  if (!hiringProgrammeNamesNeedAlign(post)) return false;
  const aligned = alignHiringProgrammeNames(post);
  const payload = {
    slug: aligned.slug,
    title: aligned.title || aligned.title_en || aligned.title_tc || aligned.title_sc || '',
    title_en: aligned.title_en || '',
    title_tc: aligned.title_tc || '',
    title_sc: aligned.title_sc || '',
    summary: aligned.summary || '',
    summary_en: aligned.summary_en || '',
    summary_tc: aligned.summary_tc || '',
    summary_sc: aligned.summary_sc || '',
    body: aligned.body || '',
    body_en: aligned.body_en || '',
    body_tc: aligned.body_tc || '',
    body_sc: aligned.body_sc || '',
    linkedinUrl: aligned.linkedinUrl || '',
    heroImageUrl: aligned.heroImageUrl || '',
    heroImageAlt: aligned.heroImageAlt || aligned.title || '',
    images: Array.isArray(aligned.images) ? aligned.images : [],
    isPublished: aligned.isPublished !== false
  };
  if (aligned.publishedAt) payload.publishedAt = aligned.publishedAt;
  const save = await fetch('/api/hiring', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify(payload)
  });
  return save.ok;
}
